import React from "react";
import { BigSpringLogo } from "./styles";
import { Box } from "../Box";

export function Logo() {
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <BigSpringLogo />
    </Box>
  );
}
